// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"20d33943","149":"71e6277c","255":"03225bdd","266":"eae6a479","333":"280c9b54","726":"daf34459","817":"0db9811e"}[chunkId] + ".chunk.js";
};